<template>
  <div class="chat">
    <Header @close="closeChat"/>
    <Body v-if="authState === 'loggedIn'" :messages="getMessages" @personTypeChange="onPersonTypeChangeWrapper"/>
    <Authorization
      v-if="authState === 'logedOut' || !authState"
      @login="authLoginWrapper"
      @registerWithPhone="authRegisterWithPhoneWrapper"
      @registerWithCaptcha = "registerWithCaptchaWrapper"
      @reset="authResetWrapper"
      @oauth="oauthWrapper"
    />
    <Footer  v-if="authState === 'loggedIn'" @send="sendMessage"/>
  </div>
</template>

<script>
import Header from './partials/Header'
import Body from './partials/Body'
import Authorization from './partials/Authorization'
import Footer from './partials/Footer'
import { mapActions, mapGetters } from 'vuex'
import { APP_URL, BASE_URL } from '../../env'

export default {
  name: 'Chat',
  components: {
    Header,
    Body,
    Authorization,
    Footer
  },
  computed: {
    ...mapGetters({
      getMessages: 'messages/getMessages',
      authState: 'chat/getAuthState'
    })
  },
  mounted () {
    this.openChat()
    this.setLocationIdWrapper(new URL(window.location).searchParams.get('loc_id'))
    this.checkOauthWrapper(new URL(window.location).searchParams.get('access_token'))
  },
  methods: {
    ...mapActions({
      sendMessage: 'messages/sendMessage',
      authLogin: 'auth/authLogin',
      authRegisterWithPhone: 'auth/authRegisterWithPhone',
      authRegisterWithCaptcha: 'auth/authRegisterWithCaptcha',
      authReset: 'auth/authReset',
      closeChat: 'chat/closeChat',
      openChat: 'chat/openChat',
      oauth: 'auth/oauth',
      setLocationId: 'chat/setLocationId',
      checkOauth: 'auth/checkOauth',
      onPersonTypeChange: 'messages/setPersonType'
    }),
    authRegisterWithPhoneWrapper (data) {
      this.authRegisterWithPhone(data)
    },
    authLoginWrapper (data) {
      this.authLogin(data)
    },
    authResetWrapper (data) {
      this.authReset(data)
    },
    registerWithCaptchaWrapper (data) {
      this.authRegisterWithCaptcha(data)
    },
    checkOauthWrapper (data) {
      this.checkOauth(data)
    },
    setLocationIdWrapper (data) {
      this.setLocationId(data)
    },
    oauthWrapper (provider) {
      // Because we are having callback inside callback, we need to encode it twice
      const internalCallback = provider === 'facebook' ? encodeURIComponent(APP_URL) : APP_URL
      const encodedCallback = encodeURIComponent(`${BASE_URL}/auth/login/oauth/${provider}/token?callback=${internalCallback}`)
      const url = `${BASE_URL}/auth/login/oauth/${provider}/redirect?callback=${encodedCallback}`
      location.href = url
    },
    onPersonTypeChangeWrapper (data) {
      this.onPersonTypeChange(data)
    }
  }
}
</script>

<style lang="scss">
.chat {
  background: #FFFFFF;
  box-shadow: 0px 8px 24px rgba(149, 157, 165, 0.2);
  border-radius: 10px;
  width: 350px;
  height: 465px;
  font-family: 'Roboto', sans-serif;
  display: flex;
  flex-direction: column;
  @media (max-width: 400px) {
    width: 300px;
  }
}

.fade-in-up-enter-active {
  transition: all 0.3s ease;
  transform: translateY(0);
}

.fade-in-up-leave-active {
  transition: all 0.3s ease;
  transform: translateY(0);
}

.fade-in-up-enter, .fade-in-up-leave-to {
  opacity: 0;
  transform: translateY(25px);
}
</style>
